export default class MassiaDateService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}
}
